<template>
  <div id="email-quotation" class="tw-w-full te-flex tw-justify-end tw-text-right">
    <a target="_blank" href="#" @click.prevent="dialog = true"><v-icon color="primary">mdi-email</v-icon>
      Send Quote to Email</a>

    <v-dialog v-model="dialog" max-width="530px">
      <v-card>
        <v-card-text>
          <card-title icon="mdi-email">Email Quote</card-title>
          <v-container class="tw-mt-2 md:tw-mt-4">
            <v-form v-model="isValid">
              <v-row class="tw-w-full tw-grid tw-grid-cols-1 tw-px-4 md:tw-px-8">
                <v-text-field
                    v-model="form.name"
                    name="name"
                    id="name"
                    label="Full Name"
                    type="text"
                    :rules="[required('Full Name')]"
                ></v-text-field>
                <v-text-field
                    v-model="form.email"
                    name="email"
                    id="email"
                    label="Email Address"
                    type="email"
                    :rules="[required('Email Address'), emailFormat()]"
                ></v-text-field>
                <v-text-field
                    v-model="form.phone_number"
                    name="phone"
                    id="phone"
                    label="Phone Number (optional)"
                    type="text"
                ></v-text-field>
                <v-btn block large
                       color="secondary"
                       class="my-3 "
                       :disabled="!isValid"
                       @click="submit"
                       :loading="loading">
                  Send Quote
                </v-btn>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="tw-flex tw-justify-end">
          <v-btn color="error" text @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CardTitle from '@/components/shared/CardTitle';
import validations from '@/utils/validations';
import axios from 'axios';
import helpers from '@/utils/helpers';
import { mapGetters } from 'vuex';

export default {
  name: 'EmailDPQuotation',
  components: { CardTitle },
  data: () => ({
    dialog: false,
    form: {
      name: '',
      email: '',
      phone_number: '',
    },
    loading: false,
    isValid: false,
    ...validations,
  }),
  computed: {
    ...mapGetters('auth', ['authenticatedUser', 'isAuthenticated']),
  },
  mounted() {
    this.form.email = this.isAuthenticated ? this.authenticatedUser.email : '';
  },
  methods: {
    submit() {
      const quote = this.$store.getters['rfq/getDPQuoteResponse'];
      this.loading = true;
      axios.post(`customer/digital-quotation/domestic-package/quotes/${quote.id}/email?email_address=${this.form.email}`, {})
        .then((response) => {
          if (response.status === 200) {
            this.$toast.success(response.data.message, 'Success');
          } else {
            this.$toast.error('Error occured! try again', 'Error');
          }
          // this.$analytics.logEvent(FB_EMAIL_QUOTE, data);
          helpers.clearForm(this.form);
          this.loading = false;
          this.dialog = false;
        });
    },
  },
};
</script>

<style>
.v-dialog{
  box-shadow: none!important;
}
</style>
